export enum TickerItemType {
  Goal = 'goal',
  FreeKick = 'free_kick',
  OwnGoal = 'own_goal',
  PenaltyGoal = 'penalty_goal',
  Substitution = 'substitution',
  Injury = 'injury',
  YellowCard = 'yellow_card',
  RedCard = 'red_card',
  YellowRedCard = 'yellow_red_card',
  TopChance = 'top_chance',
  TopParade = 'top_parade',
  TopTackle = 'top_tackle',
  TopAction = 'top_action',
  Card = 'card',
  Sharing = 'sharing',
  Lineup = 'lineup',
  Comment = 'comment',
  PhaseChange = 'phase_change',
  ThankYou = 'thank_you',
  Info = 'info',
}
